<router-outlet></router-outlet>
<!--<app-splash  *ngIf="this.global.showSplash==false"></app-splash>-->